export default __webpack_public_path__ + "static/media/7.0626ae76.svg";